<template>
  <div>
    <div class="componentTop">
      <div class="componentText">课程作业</div>
      <div>
        <a-button type="primary" icon="plus" @click="showModal()">
        新增作业
      </a-button>
      </div>
    </div>
    <div class="courseworkList">
      <div class="oneCoursework" v-for="(item, idx) in attInfoList" :key="idx">
        <div class="courseworkTop">
          <div class="titleBox">
            <a-row>
              <a-col :span="21">
                <div class="title">{{item.attTitle}}</div>
              </a-col>
              <a-col :span="3" style="display: flex;justify-content: flex-end;">
                <span style="margin-right: 20px;" @click="goEditCoursework(item)">
                  <img src="../../../../static/images/icon_edit.png" alt="">
                </span>
                <span @click="delCoursework(item)">
                  <img src="../../../../static/images/icon_trash.png" alt="">
                </span>
              </a-col>
            </a-row>
          </div>
          <div class="titleDesc">
            <a-row>
              <a-col :span="6">
                <span>题目数量：</span>
                <span>{{item.assignmentCount}}</span>
              </a-col>
              <a-col :span="6">
                <span>批改方式：</span>
                <span v-if="item.checkType == 'auto'">自动批改</span>
                <span v-if="item.checkType == 'manual'">手动批改</span>
                <span v-if="item.checkType == ''">未设置</span>
              </a-col>
              <a-col :span="6">
                <span>作业类型：</span>
                <span v-if="item.workType == 'attachment'">附件题</span>
                <span v-if="item.workType == 'test'">考试测验</span>
              </a-col>
            </a-row>
          </div>
        </div>
        <div class="courseworkMain">
          <h4>作业说明：</h4>
          <p v-html="item.attDes"></p>
        </div>
      </div>
      <div class="noSummary" v-if="attInfoList.length == 0">
        <a-icon type="smile" />
        <span>尚未发布课程作业</span>
      </div>
    </div>
    <addCoursework ref="addCoursework" @getAllAttInfo="getAllAttInfo"></addCoursework>
  </div>
</template>

<script>
import addCoursework from './component/addCoursework';

export default {
  data(){
    return {
      attInfoList: []
    };
  },
  components: {
    addCoursework
  },
  created () {
    this.getAllAttInfo();
  },
  methods: {
    getAllAttInfo(){
      let url = this.apis.coursework.getAllAttInfo + this.appUtils.getResearchId();
      this.http.get(url)
      .then((res)=>{
        this.attInfoList = res.data;
        this.$emit('getResearchMessageById');
      }).catch((err)=> {
        console.log(err);
      });
    },
    showModal(){
      this.$refs.addCoursework.showModal();
    },
    goEditCoursework(item){
      console.log(item);
      let obj ={
        attinfoId: item.attinfoId
      };
      let objStr = JSON.stringify(obj);
      sessionStorage.setItem(this.constStatic.COURSE_INFO, [objStr]);
      if (item.workType == 'attachment'){
        this.$router.push({path: '/settingWrap'});
      } else if (item.workType == 'test'){
        this.$router.push({path: '/settingWrapTest'});
      }
      // settingWrapTest
    },
    delCoursework(item){
      let that=this;
      this.$confirm({
        title: '您确定要删除该作业吗?',
        onOk() {
          that.sbmDelCoursework(item.attinfoId);
        },
        onCancel() {
        }
      });
    },
    sbmDelCoursework(attinfoId){
      let url = this.apis.coursework.delCoursework + attinfoId;
      this.http.delete(url)
      .then((res)=>{
        if (res.status == 0){
          this.$message.success('删除作业成功');
          this.getAllAttInfo();
        }
      }).catch((err)=> {
        this.$message.error(err.message);
      });
    }
  }
};
</script>

<style lang="less" scoped>
  .noSummary{
    height: 160px;
    line-height: 160px;
    color: #999999;
    text-align: center;
  }
  .componentTop{
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 25px 40px;
  }
  .componentText{
    font-size: 30px;
    color: #333333;
  }
  .courseworkList{
    padding: 0 50px 50px 30px;
    text-align: start;
    .oneCoursework{
      border:1px solid rgba(232,232,232,1);
      box-shadow:0px 4px 12px rgba(238,238,238,1);
      border-radius:2px;
      margin-bottom: 25px;
      .courseworkTop{
        height: 80px;
        background: #FAFAFA;
        border-bottom: 1px solid #E8E8E8;
        padding: 16px 43px 12px 25px;
        .titleBox{
          height: 24px;
          line-height: 24px;
          .title{
            width: 60%;
            font-size: 16px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
          span{
            display: inline-block;
            width: 24px;
            height: 24px;
            cursor: pointer;
            img{
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
        .titleDesc{
          margin-top: 5px;
          color: #999;
        }
      }
      .courseworkMain{
        padding: 25px 43px 20px 25px;
        h4{
          color: #666;
        }
        p{
          color: #999;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
</style>